import type { FaqItem } from '../components/ds';
import type { ProductPipelineMigrate } from './productShared';

export const MODELS_FAQ: readonly FaqItem[] = [
  {
    q: 'Which model does Induce use?',
    a: 'Induce orchestrates multiple best-in-class models inside Rhapsody, routing generation shot by shot.',
  },
  {
    q: 'Do I have to pick a model?',
    a: 'No. Rhapsody handles model selection so you can focus on the film.',
  },
  {
    q: 'Will output be consistent across models?',
    a: 'Yes. Every shot generates from the Project Memory Graph and is verified against it, so consistency holds whichever model renders.',
  },
  {
    q: 'Does Induce support AI-transparency rules like the EU AI Act?',
    a: 'Induce is built for them. Article 50\'s transparency obligations take effect August 2, 2026, and every shot already carries its plan, model provenance, and verification record — a disclosure trail built into the pipeline, not bolted on.',
  },
];

export const MODEL_CARDS = [
  {
    badge: 'Motion leader',
    name: 'Kling',
    version: 'Version 3.0 Omni · KuaiShou',
    desc: 'Multi-shot sequences with subject consistency across angles, plus native lip-sync in five languages. The strongest model for high-volume, motion-complex, dialogue-heavy coverage - at the lowest cost-per-second in its tier.',
    tags: ['Dialogue · Lip-sync', 'Multi-shot', 'Motion mastery', 'High volume'],
  },
  {
    badge: 'Narrative leader',
    name: 'Seedance',
    version: 'Version 2.0 · ByteDance',
    desc: 'Multi-shot storytelling in a single pass, with speech, sound effects, and music generated together. Native 15–20 second clips. Induce\'s primary engine for narrative sequences.',
    tags: ['Multi-shot native', 'Sync audio/video', 'Long-form', 'Narrative sequences'],
  },
  {
    badge: 'Quality leader',
    name: 'Veo',
    version: 'Version 3.1 · Google DeepMind',
    desc: 'Native 4K with 48kHz synchronized speech - the highest raw visual fidelity of any current model. Cinematic photorealism, physics-accurate motion, scene extension past 60 seconds.',
    tags: ['Native 4K', '48kHz speech', 'Hero shots', 'Establishing'],
  },
  {
    badge: 'Style leader',
    name: 'Nano Banana',
    version: 'Version 2 · Induce Labs',
    desc: 'Experimental cinematographic expression tuned for stylized, high-contrast, non-photorealistic output. Induce\'s proprietary model, trained on director-corrected data. Platform-exclusive.',
    tags: ['Stylized output', 'Music video', 'Mood sequences', 'Exclusive'],
  },
] as const;

export const PIPELINE_MIGRATE: ProductPipelineMigrate = {
  kicker: '- Next in the pipeline',
  title: 'Shot control shapes the cut. Rhapsody powers every frame.',
  body: 'However you override a shot, Rhapsody still routes it to the best video model for that moment and verifies the result against the story. No manual switching, no lock-in.',
  ctaLabel: 'AI Video Models',
  ctaTo: '/product/models',
} as const;

export const MODELS_SORA_MIGRATE: ProductPipelineMigrate = {
  kicker: '- Sora API shuts down September 24, 2026',
  title: "Don't wait for the deadline. Migrate now.",
  body: 'Upload your screenplay. The Project Memory Graph rebuilds in seconds, Rhapsody routes every shot to the best current model, and your verified first cut is ready in hours.',
  ctaLabel: 'Start migration',
  ctaTo: '#cta',
} as const;
